export default __webpack_public_path__ + "static/media/team6.032731a8.png";